<script lang="ts">
    import moment from "moment";
    import { api, loader, swClient, toast, user } from "../stores";
    import { onMount, getContext } from "svelte";
    import { link } from "svelte-navigator";
    import ConfirmPopup from "./ConfirmPopup.svelte";
    import type { Shop } from "../solidwind";
    import { Types } from "../model";

    const { open } = getContext("simple-modal");
    export let document;
    export let onShowProducts;

    let shopsDiv;
    let last_scroll = 0;
    let showedItems = 30;
    let nbProduct = 0;
    let participatingShops = [];
    let newShopCode: string;
    let shopSearch: string = "";
    let shops: Shop[] = [];

    let userType = null;

    onMount(async () => {
        getProducts();
        await getParticipatingShops();
    });

    async function getParticipatingShops() {
        const processId = $loader.show("Chargement des magasins participants");
        shops = await $swClient.getShops();
        const orders = await $swClient.getOrdersByDocument(document.uid);

        if (orders.length > 0) {
            orders.forEach((order, io) => {
                // console.log(order)

                shops.forEach((shop, is) => {
                    if (order.shop_uid === shop.uid) {
                        shop.orderUid = order.uid;
                        if (order.current_state.level !== "cancelled") {
                            participatingShops.push(shop);
                            participatingShops = participatingShops;
                        } else {
                            (shop as any).isCancel = true;
                        }
                    }
                    if (is === shops.length - 1 && io === orders.length - 1) {
                        participatingShops.sort(function (a, b) {
                            let textA = a.code.toUpperCase();
                            let textB = b.code.toUpperCase();
                            return textA < textB ? -1 : textA > textB ? 1 : 0;
                        });
                        $loader.hide(processId);
                    }
                });
            });
        } else {
            $loader.hide(processId);
        }
    }

    function getProducts() {
        const processId = $loader.show("Chargement des détails du document");
        $swClient.getProductsByDocument(document.uid).then(
            (res) => {
                nbProduct = res.length;
                $loader.hide(processId);
            },
            (err) => {
                console.error(err);
                $loader.hide(processId);
            }
        );
    }

    function onRemoveOrder(shop: Shop) {
        open(
            ConfirmPopup,
            {
                onOkay: () => cancelOrderAsync(shop.orderUid),
                title: `Supprimer le magasin ${shop.code} - ${shop.name} du document ${document.name} ?`,
                content: "",
            },
            { closeOnOuterClick: false, closeOnEsc: false, closeButton: false }
        );
    }

    const cancelOrderAsync = async (orderUid: string) => {
        if (orderUid && orderUid !== "") {
            const processId = $loader.show(
                "Suppression du magasin en cours..."
            );
            try {
                await $swClient.put(
                    `/v2/orders/${orderUid}/cancel`,
                    { reason: "cancelled by admin" },
                    null
                );
                $toast.success("Magasin supprimé avec succès");
            } catch (err) {
                $toast.error(`Une erreur s'est produite : ${err}`, 10000);
            } finally {
                $loader.hide(processId);
            }
        }
    };

    function onAddOrder() {
        const exist = participatingShops
            .map((ps) => ps.code)
            .includes(newShopCode);
        if (!exist) {
            if (newShopCode.length === 4) {
                open(
                    ConfirmPopup,
                    {
                        onOkay: () => createOrder(),
                        title: `Ajouter le magasin ${newShopCode} au document ${document.name} ?`,
                        content: "",
                    },
                    {
                        closeOnOuterClick: false,
                        closeOnEsc: false,
                        closeButton: false,
                    }
                );
            } else {
                $toast.error(`Entrez un code magasin à 4 chiffres`);
            }
        } else {
            $toast.error(`Le magasin existe déjà`);
        }
    }

    /**
     * Create an order for the shop with code == newShopCode
     */
    async function createOrder() {
        const processId = $loader.show("Ajout du magasin en cours...");
        try {
            await $api.addOrderOnDocument(
                document.uid,
                newShopCode,
                $swClient.token
            );
            $toast.success(`Magasin ajouté au document`);
        } catch (err) {
            $toast.error(`Une erreur s'est produite : ${err}`, 10000);
        } finally {
            $loader.hide(processId);
            newShopCode = null;
        }
    }

    async function wheelEvent(event) {
        if (event.deltaY > 0) {
            showedItems++;
        }
    }

    async function handle_scroll(event) {
        if (shopsDiv.scrollTop > last_scroll) {
            showedItems++;
        }
        last_scroll = shopsDiv.scrollTop;
    }
</script>

<div>
    <h1>{document.name}</h1>
    <h5>
        Du {moment(document.startDate).format("DD/MM/YYYY")} au {moment(
            document.endDate
        ).format("DD/MM/YYYY")}
    </h5>

    <!-- {#if document.geo_area.name}
        <p>Centrale: <b>{document.geo_area.name}</b></p>
    {/if}
    <p>
        Nombre total de produits: <b>{nbProduct}</b>
        <br>
        {#if $user.checkType(UtName.elpev) || (document.campaign_type_name !== Types.campaign.types.regional && document.campaign_type_name !== Types.campaign.types.local)}
            <button class="button is-info" on:click="{() => {onShowProducts(document.uid);}}">
                Voir les produits
            </button>
        {/if}
    </p> -->

    Ajouter un magasin :
    <div class="field has-addons">
        <div class="control">
            <input
                class="input is-dark"
                type="text"
                maxlength="4"
                placeholder="Code magasin"
                bind:value={newShopCode}
            />
        </div>
        <div class="control">
            <!-- svelte-ignore a11y-missing-attribute -->
            <a class="button add" on:click={() => onAddOrder()}>
                Ajouter
            </a>
        </div>
    </div>

    {#if participatingShops && participatingShops.length > 0}
        <p>Liste des magasins participants :</p>
        <input
            class="input is-dark"
            type="text"
            placeholder="Rechercher un magasin (2 caractères minimum)"
            bind:value={shopSearch}
        />
        <ul
            class="shop_list"
            bind:this={shopsDiv}
            on:wheel={wheelEvent}
            on:scroll={handle_scroll}
        >
            {#each participatingShops as shop, i}
                {#if (shopSearch === "" && i < showedItems) || (shopSearch.length > 1 && (shop.code.includes(shopSearch) || shop.name
                                .toUpperCase()
                                .includes(shopSearch.toUpperCase())))}
                    <li class="shop_link">
                        <a
                            href="/catalog/{document.name
                                .split('_')[0]
                                .replace(
                                    /([0-9]{2}G[0-9]{3}G)([A-Z])/gm,
                                    `$1`
                                )}/{shop.code}"
                            use:link
                            target="_blank"
                        >
                            {shop.code} - {shop.name}
                        </a>
                        <button
                            class="button is-danger is-light is-small"
                            on:click={() => onRemoveOrder(shop)}
                        >
                            <span class="fas fa-times" />
                        </button>
                    </li>
                {/if}
            {/each}
        </ul>
    {/if}
</div>

<style lang="scss">
    @import "../styles/variables";

    h1 {
        color: $dark-black;
    }

    a {
        color: black;
    }

    input {
        border-radius: 10px;
    }
    .button.add {
        background-color: $dark-black;
        color: white;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    .button.is-danger {
        border-radius: 10px;
    }

    .shop_list {
        list-style: circle;
        height: 450px;
        overflow-x: auto;
    }
</style>
